// extracted by mini-css-extract-plugin
export default {"pageBody":"App_pageBody__Avkva"};